import React, { useEffect, useState } from 'react';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import SecondaryTabbedComponent from '../../shared/components/layout/SecondaryTabbedComponent';
import AccommodationDetails from './AccommodationDetails';
import Button from '../../shared/components/ui/Button';
import SaleOverview from './SaleOverview';
import DealsDetails from './DealsDetails';
import ScheduleDetails from './ScheduleDetails';
import ActivityList from './ActivityList';
import SaleAttachmentList from './SaleAttachmentList';
import { useLocation, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getLeadByID, getUnderConsiderationById } from '../services/api/implementation/impl';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import Logs from './Logs';
import DealsList from './DealsList';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const UnderConsiderationDetails = () => {
  const userId = Cookies.get('userId');
  const { id } = useParams();
  const { collapsed } = useSidebar();
  const { status } = useLocation().state || {};

  /* 
    Meta data
  */
  const secondaryTabbedComponentMetaData = {
    tabs: ['Stages', 'Logs']
  };

  /* 
    Local state
  */
  const [secondaryTab, setSecondaryTab] = useState('Stages');
  /* 
    JSX
  */
  return (
    <>
      {/* Main content */}
      <Layout>
        {/* Header */}
        <div
          className={`fixed top-0 z-10 transition-all duration-300 ease-in-out bg-white
    ${collapsed ? 'left-[76px] w-[calc(100%-76px)]' : 'left-64 w-[calc(100%-16rem)]'}
  `}>
          <Header data={{ name: `Sales > ${status || 'Unknown'}` }} backArrow={true} />
        </div>

        {/* Secondary Tabbed content */}
        <div
          className={` ${collapsed ? 'w-[100%] pl-3' : 'w-[100%]'} flex flex-col justify-start items-center mt-[4rem]`}>
          <SaleOverview leadID={id} type="underConsideration" />
        </div>

        <div
          className={` ${collapsed ? 'w-[100%] pl-7 pr-4' : 'w-[100%] pl-4 pr-4'} flex flex-col justify-start items-center `}>
          <SecondaryTabbedComponent
            data={secondaryTabbedComponentMetaData}
            activePrimary={secondaryTab}
            onChangePrimaryTab={(tab) => setSecondaryTab?.(tab)}
            rounded={true}></SecondaryTabbedComponent>

          {secondaryTab === 'Stages' && <ActivityList salesId={id ? parseInt(id) : undefined} />}
          {secondaryTab === 'Logs' && <Logs salesId={id ? parseInt(id) : undefined} />}
        </div>
      </Layout>
    </>
  );
};

export default UnderConsiderationDetails;
